import { Avatar, Tooltip, type AvatarProps } from "@fluentui/react-components";
import { useMemo } from "react";
import { useCatalogStore } from "@/store/catalog-store";
import { personFace } from "./person-face";

export function useDeletedNames(): ReadonlySet<string> {
  const resources = useCatalogStore((s) => s.resources);
  return useMemo(() => {
    const names = new Set<string>();
    for (const resource of Object.values(resources)) {
      if (resource.accountDeleted && resource.displayName) names.add(resource.displayName);
    }
    return names;
  }, [resources]);
}

/**
 * 사람 프로필은 이름 글자가 아니라 사람 아이콘이다.
 * 올린 사진이 있으면 그 사진을 쓰고, 없으면 Fluent Avatar의 기본 사람 아이콘을 쓴다.
 * 이름 이니셜과, 이름이 들어간 이모지는 얼굴로 그리지 않는다.
 */
export function PersonAvatar({
  name,
  size = 20,
  className,
  image,
  tip = true,
}: {
  name: string;
  size?: AvatarProps["size"];
  className?: string;
  /** 계정에 올린 사진. 없으면 사람 아이콘. */
  image?: string;
  /** 바깥에 이미 이름이나 툴팁이 있으면 끈다. */
  tip?: boolean;
}) {
  const deleted = useDeletedNames().has(name);
  const face = personFace(name, deleted);
  const avatar = (
    <Avatar
      size={size}
      color="neutral"
      className={className}
      aria-label={tip ? face.label : undefined}
      aria-hidden={tip ? undefined : true}
      image={image ? { src: image } : undefined}
    />
  );
  if (!tip) return avatar;
  return (
    <Tooltip content={face.label} relationship="label">
      {avatar}
    </Tooltip>
  );
}
